// Zustand 5 UI-only store per ADR-013 §8. Server-derived state belongs
// in TanStack Query (src/api/queryClient.ts); this store holds pure UI:
// rail collapse, command palette state, sudo countdown visibility,
// impersonation banner state, etc.
//
// Phase 1 scaffold ships only the left-rail collapse. Plan madde 11
// expands with: impersonation session banner state, sudo timer state,
// command palette open/close.

import { create } from "zustand";

interface UiState {
  leftRailExpanded: boolean;
  /**
   * Dar ekranda kenar çubuğunun içeriğin ÜSTÜNDE açık olup olmadığı (SEM-4931).
   *
   * `leftRailExpanded`'dan AYRI bir eksen: tek bayrak olsaydı telefonda menüyü
   * kapatmak masaüstünde çubuğu ikon şeridine düşürürdü. Kalıcı DEĞİL — bir
   * örtü paneli sayfa yüklenince kapalı doğmalı.
   */
  mobileNavOpen: boolean;
  toggleLeftRail: () => void;
  setLeftRailExpanded: (next: boolean) => void;
  toggleMobileNav: () => void;
  setMobileNavOpen: (next: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  leftRailExpanded: true,
  mobileNavOpen: false,
  toggleLeftRail: (): void =>
    set((state) => ({ leftRailExpanded: !state.leftRailExpanded })),
  setLeftRailExpanded: (next: boolean): void => set({ leftRailExpanded: next }),
  toggleMobileNav: (): void => set((state) => ({ mobileNavOpen: !state.mobileNavOpen })),
  setMobileNavOpen: (next: boolean): void => set({ mobileNavOpen: next }),
}));
